import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { ConfigService } from '@shared/services';
import { Roles } from '@shared/enums/roles.enum';

@Injectable({
	providedIn: 'root'
})
export class RoleService {

	constructor(private keycloakAngular: KeycloakService, private configService: ConfigService) {
	}

	getRoles(): string[] {
		if (!this.keycloakEnabled()) {
			return [];
		}
		return this.keycloakAngular.getUserRoles(true);
	}

	// Ohne Keycloak (lokale Entwicklung) gibt es keine Einschränkung
	hasRole(role: string): boolean {
		if (!this.keycloakEnabled()) {
			return true;
		}
		return this.getRoles().indexOf(role) > -1;
	}

	hasAnyRole(roles?: string[]): boolean {
		if (!roles || roles.length === 0) {
			return true;
		}
		if (!this.keycloakEnabled()) {
			return true;
		}
		const userRoles = this.getRoles();
		return roles.some((role: string) => {
			return userRoles.indexOf(role) > -1;
		});
	}

	isAdmin(): boolean {
		return this.hasAnyRole([Roles.Admin, Roles.QWiz, Roles.Hedgehog]);
	}

	private keycloakEnabled(): boolean {
		return !!this.configService.getConfig()?.keycloak?.enabled;
	}
}
